import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { PhrutillsService } from 'src/app/generic/phrutills.service';
import { SymptomsCheckerService } from 'src/app/services/symptoms-checker.service';
import { PatientPersonalInfo } from 'src/app/models/verifypatient/verifypatient';
import { Spinner, NgxSpinnerService } from 'ngx-spinner';

@Component({
  selector: 'app-followup',
  templateUrl: './followup.component.html',
  styleUrls: ['./followup.component.css']
})
export class FollowupComponent {
  patientPersonalInfo: PatientPersonalInfo = new PatientPersonalInfo();
  personalInfo = {
    has_patient_active_med: true,
    last_icds_and_labs: "",
    patient_account: 101116356542153,
    patient_dob: "10/02/2021",
    patient_gender: "Female",
    patient_rov: "follow up visit",
    practice_code: 1011163,
    provider_code: 53481719,
    will_intake_form_show: true,
  };
  initForm = true;
  lastStep = false;
  
  constructor(private spinner: NgxSpinnerService, private router: Router, private phrUtils: PhrutillsService, 
    private symptomsService: SymptomsCheckerService) {
      let info = localStorage.getItem('PersonalInfo');
      if(this.patientPersonalInfo && this.patientPersonalInfo.REASON_NAME != "follow up reason"){
        //return back froom here
      }
      // this.initFollowUpQuesitons();
      this.startOver();
    }
    
    initialResp: any = null;
    initFollowUpQuesitons(){
      this.spinner.show();
      let lang = localStorage.getItem('language');
      if (!lang)
        lang = 'en';

      this.symptomsService.initialQuestions(this.personalInfo,lang)
      .subscribe((res:any) => {
        this.spinner.hide();
        this.initialResp = res;
        this.initForm = true;
        this.lastStep = false;
        this.followUpResp.length = 0;
        this.followUpResp = [];
        this.initialFollowUp = null;
      },(error :any)=>{
        this.spinner.hide();
        //console.log(error.statusText);
      });
    }
    
    initialFollowUp: any = null;
    values : string[] = [];
    multipleQuestion: any = {};
    value: string = "";
    mulAnsMulQuestions: any[] = [];
    initFormChange(e: any, index: number, multiple: string){
      
      // multiple questions
      if(this.followUpResp.length > 0 && this.followUpResp[this.followUpResp.length-1].question_options.Form_Order.length > 1){
        if(multiple == 'true') {
          if(e.target.type == 'checkbox'){
            let options = [];
            if(typeof this.mulAnsMulQuestions[index] === 'undefined') {
              options.push(e.target.value);
            }
            else {
              options = this.mulAnsMulQuestions[index];
              options.push(e.target.value);
            }
            this.mulAnsMulQuestions[index] = options;
            this.multipleQuestion[this.followUpResp[this.followUpResp.length-1].question_options.Form_Order[index]] = {value : this.mulAnsMulQuestions[index]};
          }
          else{
            this.multipleQuestion[this.followUpResp[this.followUpResp.length-1].question_options.Form_Order[index]] = {value : e.target.value};
          }
          
        }
      }
      else {
        if(e.target.type == "checkbox"){
          if(e.target.checked){
            this.values.push(e.target.value);
          }
          else{
            const index = this.values.indexOf(e.target.value, 0);
            if (index > -1) {
              this.values.splice(index, 1);
            }
          }
        }
        else if(e.target.type == "radio"){
          this.value = e.target.value;
        }
      }
      this.initialFollowUp = 
      {
        answer: multiple == 'true' ? this.multipleQuestion : {
          [this.initForm ? this.initialResp.question_options.Form_Order[0] : this.followUpResp[this.followUpResp.length-1].question_options.Form_Order[0]] :  {
            value: e.target.type == "checkbox" ? this.values : this.value,
          },
          symptom: {
            value: this.initForm ? this.initialResp.question : this.followUpResp[this.followUpResp.length-1].question
          },
        },
        patient_account : this.personalInfo.patient_account,
      }
    }
    
    followUpResp: any[] = [];
    nextClicked(currentForm: any){ 
       
      if(this.initForm){
        let obj = this.initialFollowUp
        if(!this.initialFollowUp){
          this.phrUtils.showError("Please select "+this.initialResp.question_options.Form_Order+".");
          return;
        }
      }
      else {
        if(!this.initialFollowUp){
          this.phrUtils.showError("Please select "+this.initialResp.question_options.Form_Order+".");
          return;
        }
      }
      
       
      if(this.initForm){
        this.spinner.show();
        let lang = localStorage.getItem('language');
        if (!lang)
          lang = 'en';
        this.symptomsService.sendSymptoms(this.initialResp.destination_url, this.initialFollowUp, lang)
        .subscribe((res:any) => {
          this.initialFollowUp = null;
          
          this.spinner.hide();
          if(res){
            this.followUpResp.push(res);
            if(this.followUpResp[this.followUpResp.length-1].destination_url == "initial_symptoms" && this.followUpResp[this.followUpResp.length-1].screen == "model_screen"){
              this.router.navigateByUrl("patient/symptomsmale");
              return
            }
            this.lastStep = this.followUpResp[this.followUpResp.length-1].destination_url == "" ? true : false;
            this.initForm = false;
          }
        },(error :any)=>{
          this.spinner.hide();
          this.phrUtils.showError(error.statusText);
        });
      }
      else{
        this.spinner.show();
        let lang = localStorage.getItem('language');
        if (!lang)
          lang = 'en';
        this.symptomsService.sendSymptoms(this.followUpResp[this.followUpResp.length-1].destination_url, this.initialFollowUp, lang)
        .subscribe((res:any) => {
          
          this.spinner.hide();
          if(res){
            this.followUpResp.push(res);
            if(this.followUpResp[this.followUpResp.length-1].destination_url == "initial_symptoms" && this.followUpResp[this.followUpResp.length-1].screen == "model_screen"){
              this.router.navigateByUrl("patient/symptomsmale");
              return
            }
            this.lastStep = this.followUpResp[this.followUpResp.length-1].destination_url == "" ? true : false;
          }
        },(error :any)=>{
          this.spinner.hide();
          this.phrUtils.showError(error.statusText);
        });
      }
    }
    
    startOver(){
      this.initialResp = null;
      this.spinner.show();
      let lang = localStorage.getItem('language');
      if (!lang)
        lang = 'en';
      this.symptomsService.startOver(this.personalInfo,lang)
      .subscribe((res:any) => {
        this.initFollowUpQuesitons();
      },(error :any)=>{
        this.spinner.hide();
        //console.log(error.statusText);
      });
    }
    
    
    finish(){
      this.router.navigateByUrl("patient/thank-you");
    }
    
  }
